var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4WcDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 58.31a3 3 0 01-1.83.62 3 3 0 01-2.38-1.17L48.58 47H31a3 3 0 01-3-3V27.45a3.06 3.06 0 012.09-3c.244-.07.496-.111.75-.12a3.71 3.71 0 012 .58C35.41 26.42 47 33.32 47 33.32a2.07 2.07 0 011 2.35 2 2 0 01-1.92 1.43 2.07 2.07 0 01-1-.24L34 30.28V41h16a2.998 2.998 0 012.38 1.17L61.6 54.1a2.999 2.999 0 01-.6 4.21zm-30 2a13.08 13.08 0 01-7-23v-4.9a17.08 17.08 0 1024 21.81l-2.9-3.78A13.1 13.1 0 0131 60.26v.05zm3.3-39.35a5 5 0 10-7-.8 5 5 0 007.01.75l-.01.05z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_WC_disabled.2c78c504.svg";
export { SvgE4WcDisabled as ReactComponent };